<template>
  <lazy-div :load="doInit">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-flex xs4>
              <div class="headline">Account List</div>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs4>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            </v-flex>
            <!-- <v-flex xs4>
              <v-layout row>
                <v-spacer></v-spacer>
                <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                  <v-btn color="secondary" class="white--text" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                  <v-card>
                    <v-card-text>
                      <template v-if="columns.length > 0">
                        <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                      </template>
                      <template v-else>
                        No column found
                      </template>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-layout>
            </v-flex> -->
          </v-card-title>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-data-table
            v-bind:headers="headers"
            v-bind:items="items"
            v-bind:search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="index"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span v-on="on">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:item="row">
              <tr>
                <td class="text-xs-left">{{ row.item.branch }}</td>
                <td class="text-xs-left">{{ row.item.tranType }}</td>
                <td class="text-xs-left">{{ row.item.docNo }}</td>
                <td class="text-xs-left">{{ row.item.fund }}</td>
                <td class="text-xs-left">{{ row.item.acctNoSfx }}</td>
                <td class="text-xs-left">{{ formatDate(row.item.tranDate) }}</td>
                <td class="text-xs-left">{{ row.item.curr }}</td>
                <td class="text-xs-left">{{ formatDisplayNumber(row.item.osBal) }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery" :loading="loading"></table-action>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </lazy-div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/reusable/listMixins'
import { formatDisplayNumber } from '@/utils/number'
export default {
  data() {
    return {
      headers: [
        { text: 'Branch', value: 'branch' },
        { text: 'Type', value: 'tranType' },
        { text: 'Doc No.', value: 'docNo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Suffix', value: 'acctNoSfx' },
        { text: 'Trans Date', value: 'tranDate' },
        { text: 'Curr', value: 'curr' },
        { text: 'OS Balance', value: 'osBal' },
        TableConst.tableActionHeader
      ],
      pagination: {
        page: 1,
        sortBy: ['branch']
      },
      menu: []
    }
  },
  watch: {
    fetchAccount: function (value) {
      if (value !== false) {
        this.doInit()
      }
    }
  },
  computed: {
    ...mapGetters(['checkAccess'])
  },
  methods: {
    async doInit() {
      this.loading = true
      const apiURI = this.$store.state.adminInter.intermediary.menu.acctList
      if (apiURI) {
        try {
          const expand = {
            inter: this.inter
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((account) => {
              const convertAccount = {
                branch: account.branch,
                tranType: account.tranType,
                docNo: account.docNo,
                fund: account.fund,
                acctNoSfx: account.acctNoSfx,
                tranDate: account.tranDate,
                curr: account.curr,
                osBal: account.osBal,
                acctNo: account.acctNo,
                rbcTran: account.rbcTran,
                netAmount: account.netAmount
              }
              this.items.push(convertAccount)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (error) {
          const { data } = error
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            this.loading = false
          }
        }
      } else {
        this.loading = false
      }
    },
    doQuery(data) {
      this.loading = true
      this.$emit('doQuery', data.item)
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  props: {
    fetchAccount: {
      type: Boolean,
      default: false
    },
    inter: {
      type: String,
      default: ''
    }
  },
  mixins: [listMixin, MessageMixin]
}
</script>

<style>
</style>
